import React from 'react';
import Modal from 'ui-v2/components/Modal';
import { Typography } from 'ui-v2/components/Typography';
import Icon from 'ui-v2/components/Icon/Icon';
import s from './CartItemPopUp.module.scss';
import { Button } from 'ui-v2/components/Button';
import { semanticColors } from 'ui-v2/tokens/colors';

export default function CartItemPopUp({ onClose, onClick, title }) {
  return (
    <Modal
      show
      variant="popup"
      head={{ show: true, onClose: onClose }}
      rootStyle={{
        zIndex: 12,
      }}
      customeBodyStyle={{
        paddingTop: '56px',
      }}
    >
      <div className={s.trash}>
        <Icon name="TrashBold" width={32} height={32} color="negative" />
      </div>
      <div className={s.midStack}>
        <Typography label="Remove item from bag?" variant="h_4_bold" />
        <Typography
          label={`${title} will be removed from your cart?`}
          variant="body_3_medium"
          color="secondary"
        />
      </div>

      <div className={s.button}>
        <Button
          onClick={onClick}
          style={{
            backgroundColor: semanticColors.bg.negative_secondary,
          }}
          variant="negative"
          size="medium"
          rightIcon={
            <Icon name="ChevronRightRegular" width={20} height={20} color="negative" />
          }
          label="Yes Remove"
          fullWidth
        />
      </div>
    </Modal>
  );
}
